var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("1、资产、负债和所有者权益是（）。")]),_vm._v(" A、表示企业经营成果的会计要素 "),_c('br'),_c('br'),_vm._v(" B、表示企业经营状况的会计要素"),_c('br'),_c('br'),_vm._v("  C、表示企业财务状况的会计要素 "),_c('br'),_c('br'),_vm._v(" D、表示企业现金流量的会计要素 ")])
}]

export { render, staticRenderFns }